module.exports = __webpack_public_path__ + "img/logo2.6b6b6ffc.png";